import { Stack } from "@mui/material";
import React from "react";
import { CustomButton } from "./CustomButton";

type Props = {
  currentTab: string;
  onChange: (tab: string) => void;
  tabList: string[];
  isTabsCenter?: boolean;
  fullWidth?: boolean;
  isVertical?: boolean;
};

export const ButtonTabs = ({
  currentTab,
  onChange,
  tabList,
  isTabsCenter,
  fullWidth,
  isVertical = false,
}: Props) => {
  return (
    <Stack
      direction={isVertical ? "column" : "row"}
      gap="8px"
      justifyContent={isTabsCenter ? "center" : "flex-start"}
    >
      {tabList.map((tab) => {
        if (!tab) return null;
        return (
          <CustomButton
            key={tab}
            onClick={() => onChange(tab)}
            variant="text"
            type="button"
            fullWidth={fullWidth}
            sx={{
              gap: 0,
              textWrap: "nowrap",
              color: `${currentTab === tab ? "#1C3C6C" : "#4C545B"}`,
              cursor: `${currentTab === tab ? "auto" : "pointer"}`,
              backgroundColor: `${
                currentTab === tab ? "#F1F1F1" : "rgba(241, 241, 241, 0.3)"
              }`,
              "&:hover": {
                color: "#1C3C6C",
                backgroundColor: "#F1F1F1",
              },
              height: "40px",
            }}
            customSize="fit"
          >
            {tab}
          </CustomButton>
        );
      })}
    </Stack>
  );
};
